import { Box, Stack } from '@mui/system';
import { PropsWithChildren, ReactNode } from 'react';

import Typography from '@mui/material/Typography';
import { Variant } from '@mui/material/styles/createTypography';

interface IProps extends PropsWithChildren {
  title: string;
  titleType?: Variant;
  footer?: ReactNode;
  footerRight?: ReactNode;
  footerLeft?: ReactNode;
  headerRight?: ReactNode;
  description?: string;
  titleChildren?: ReactNode;
  onNext?: () => void;
  onPrevious?: () => void;
}

export const InsuredEntityPageContainer = ({
  title,

  description,
  children,
  titleChildren,
  onNext,
  onPrevious,
}: IProps) => {
  return (
    <Box className={`claim-entity-page-container`}>
      <Stack alignItems="left" className="claim-entity-page-header">
        <Typography variant="h5" className="main-contact-title">
          {title}
        </Typography>
        {description && (
          <Box
            style={{
              backgroundColor: 'white',
              paddingBottom: `${titleChildren ? '0px' : '20px'}`,
            }}
          >
            {description}
          </Box>
        )}
        {titleChildren && <Box>{titleChildren}</Box>}
      </Stack>
      <Box
        className={`claim-entity-page-content ${description ? '' : 'mt-120'}`}
      >
        {children}
      </Box>
    </Box>
  );
};
